import { css } from "@compiled/react";

import Video from "@/components/wpl/video/src";
import { Row } from "@/libraries/wpl/foundations/src";

const VideoSection = () => {
    return (
        <Row layout="12">
            <Video
                loop
                muted
                videoLink="https://wac-cdn-2.atlassian.com/video/upload/f_auto,q_auto/misc-assets/videos/jira-product-discovery/JPD_product-tour_hero.mp4"
                css={css({
                    filter: "drop-shadow(2px 4px 6px rgba(0, 0, 0, 0.3))"
                })}
            />
        </Row>
    );
};

export default VideoSection;
